import axios from "axios";


const BASE_URL = 'https://api.motorevents.com.au/api/';

export const apiPostContactUs = (first_name, email, message) => {
    return axios.post(BASE_URL + 'contact_us',
        {
            first_name,
            email,
            message
        }
    );

};